// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Terms_iframe__2jw3x","terms":"Terms_terms__1h-eH","table":"Terms_table__39Ev5"};